<div class="modal-header">
  <button type="button" class="btn-close" (click)="bsModalRef.hide()" [attr.aria-label]="'button.close' | translate"></button>
</div>

<div class="modal-body">
  <app-imprint-page
    *ngIf="template === 'imprint'"
    [showBreadcrumb]="false"
  ></app-imprint-page>
  <app-terms-of-service-page
    *ngIf="template === 'terms-of-service'"
    [showBreadcrumb]="false"
  ></app-terms-of-service-page>
  <app-privacy-terms-page
    *ngIf="template === 'privacy-terms'"
    [showBreadcrumb]="false"
  >
  </app-privacy-terms-page>
  <app-system-requirements-page
    *ngIf="template === 'system-requirements'"
    [showBreadcrumb]="false"
  >
  </app-system-requirements-page>
  <app-contact-page
    *ngIf="template === 'contact-sdv'"
    [showBreadcrumb]="false"
  >
  </app-contact-page>
  <app-consent-proctoring-page
    *ngIf="template === 'consent-proctoring-sdv'"
    [showBreadcrumb]="false"
  >
  </app-consent-proctoring-page>
</div>
<div class="modal-footer justify-content-end">
  <button
    class="btn btn-outline-primary"
    (click)="bsModalRef.hide()"
  >
    {{ 'button.close' | translate }}
  </button>
</div>
